import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/villari.webp';
import screenshot_target from '../../../images/letterfunnel/olivierbaas.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Olivier Baas"
      firstname="Olivier"
      companyname="Villari"
      competition="Transmission Dynamics en Resensys"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/olivierbaas.js